module.exports = __webpack_public_path__ + "media/src/images/invoice-02-a3538b62a17ca9407ed2e30dbf417dad.png";